
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { listadoCiudades, listadoRegiones } from "../../services";








const storeApi = (set) => ({

    activeCiudad: null,
    ciudades: [],

    activeRegion: null,
    regiones: [],




    startListadoCiudades: async(region) => {
        try {
            const data = await listadoCiudades(region);
            set({ ciudades: data });
            return true;
        } catch (error) {
            return false;
        }
    },



    startListadoRegiones: async() => {
        try {
            const data = await listadoRegiones();
            set({ regiones: data });
            return true;
        } catch (error) {
            // Swal.fire('Error', error.message, 'error');
            return false;
        }
    },


});





export const useCiudadesStore = create()(
    devtools(
        storeApi
    )
)
